import React from "react";
import styled from "styled-components";
import { Flex } from "rebass/styled-components";

import { SystemMessage } from "components/composerv2/styles";

const DismissButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.text04};

  &:hover {
    color: ${props => props.theme.colors.text01};
  }

  i {
    font-size: 16px;
  }
`;

const Container = styled(Flex)`
  align-items: flex-start;
  gap: 8px;

  > *:first-child {
    flex: 1;
  }
`;

interface DismissibleNotificationProps {
  type: "warning" | "error" | "info";
  service?: string;
  onDismiss: () => void;
  children: React.ReactNode;
}

const DismissibleNotification: React.FC<DismissibleNotificationProps> = ({
  type,
  service,
  onDismiss,
  children
}) => {
  return (
    <Container data-testid={`composer-notification-${type}`}>
      <SystemMessage type={type} service={service}>
        {children}
      </SystemMessage>
      <DismissButton
        onClick={onDismiss}
        aria-label="Dismiss notification"
        data-testid="dismiss-notification"
      >
        <i className="icon-cancel" />
      </DismissButton>
    </Container>
  );
};

export default DismissibleNotification;
